const lang = {
  title_page: process.env.MIX_APP_NAME,
  title: 'パスワード再設定',
  content: 'パスワード再設定画面の有効期限が切れました。<br/>再度申込みしてください。',
  button: 'パスワード再設定申込み',
}

export default lang
